import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title", "tabindex"]
const _hoisted_2 = ["data-src", "alt"]

import { computed, onBeforeUnmount, onMounted, ref, useTemplateRef } from 'vue';
import GalleryPlayButton from './GalleryPlayButton.vue';
import type { GalleryElement } from '@/interfaces/components/galleryElement';

interface FigureGridItemProps {
	content: GalleryElement['content'];
	preview: GalleryElement['preview'];
	type: GalleryElement['type'];
	copyright: GalleryElement['copyright'];
	alt?: GalleryElement['alt'];
	aspectRatio?: GalleryElement['aspectRatio'];
	tabindex?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FigureGridItem',
  props: {
    content: {},
    preview: {},
    type: {},
    copyright: {},
    alt: {},
    aspectRatio: { default: 1.6 },
    tabindex: { default: 1 }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "82d14074": (_aspectRatio.value)
}))


const isVideo = computed(() => ['youtube', 'vimeo', 'ytube'].includes(__props.type));
const _copyright = computed(() => {
	if (__props.copyright.includes('©')) {
		return __props.copyright;
	}
	if (__props.copyright.includes('&copy;')) {
		return __props.copyright.replace('&copy;', '©');
	}
	return `© ${__props.copyright}`;
});
const isLoaded = ref(false);
const figureRef = useTemplateRef('figureRef');
const imageRef = useTemplateRef('imageRef');

const blockClassModifiers = computed(() => ({ 'gallery-grid-item--video': isVideo, 'gallery-grid-item--loaded': isLoaded.value }));
const _aspectRatio = computed(() => {
	return isLoaded.value ? 'auto' : __props.aspectRatio;
});

const preloadImage = () => {
	if (!imageRef.value) return;
	imageRef.value.src = imageRef.value.getAttribute('data-src') as string;
};
const scrollIntoView = () => {
	if (!figureRef.value) return;
	setTimeout(() => {
		figureRef.value?.scrollIntoView({
			behavior: 'smooth',
			block: 'center',
			inline: 'center',
		});
	}, 30);
};

const observer = new IntersectionObserver(
	function (entries, self) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				preloadImage();
				self.unobserve(entry.target);
			}
		});
	},
	{
		root: null,
		rootMargin: '40px 0px 40px 0px',
		threshold: 0,
	}
);

onMounted(() => {
	if (!figureRef.value) return;
	observer.observe(figureRef.value);
});
onBeforeUnmount(() => {
	observer.disconnect();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", {
    ref_key: "figureRef",
    ref: figureRef,
    class: _normalizeClass(['gallery-grid-item', blockClassModifiers.value]),
    title: _copyright.value,
    tabindex: _ctx.tabindex,
    onFocus: scrollIntoView
  }, [
    _createElementVNode("figcaption", null, _toDisplayString(_ctx.alt), 1 /* TEXT */),
    _createElementVNode("img", {
      ref_key: "imageRef",
      ref: imageRef,
      class: _normalizeClass(['gallery-grid-item__image', { 'gallery-grid-item__image--loaded': isLoaded.value }]),
      "data-src": isVideo.value ? _ctx.preview : _ctx.content,
      alt: _ctx.alt ?? _copyright.value,
      onLoad: _cache[0] || (_cache[0] = ($event: any) => (isLoaded.value = true))
    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2),
    (isVideo.value)
      ? (_openBlock(), _createBlock(GalleryPlayButton, {
          key: 0,
          class: "gallery-grid-item__play-button"
        }))
      : _createCommentVNode("v-if", true)
  ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1))
}
}

})